import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { WebSocketRecord } from "../types/webSocket";

export const fetchWebSocketApi = async (config: {
  "websocket-id": string;
  "app-id": string;
}): Promise<WebSocketRecord> => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
(datastore Qo.Public.Api.WebSocket "omega/query-omega/public/api/websocket")
(= Input ${ednString})
(Qo.Public.Api.WebSocket/get-websocket Input Response)
(return [Response])
  `;
  return queryOmegaSingleResult(query);
};
